import { rootApi } from "../rootApi";

export const externalVehicleApi = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    // List (paged)
    getExternalVehicles: builder.query({
      query: (params) => ({
        url: "v1/ExternalVehicle",
        method: "GET",
        params: {
          pageNumber: params.pageNumber,
          pageSize: params.pageSize,
          searchText: params.searchText || ""
        }
      }),
      transformResponse: (resp) => resp?.data ?? { items: [], totalCount: 0, pageNumber: 1, pageSize: 10, totalPages: 0 },
      providesTags: (result) =>
        result?.items
          ? [
              ...result.items.map((r) => ({ type: "ExternalVehicle", id: r.id })),
              { type: "ExternalVehicle", id: "LIST" }
            ]
          : [{ type: "ExternalVehicle", id: "LIST" }]
    }),

    // Get by ID (detail)
    getExternalVehicleById: builder.query({
      query: (id) => ({
        url: `v1/ExternalVehicle/${id}`,
        method: "GET"
      }),
      transformResponse: (resp) => resp?.data ?? null,
      providesTags: (result, error, id) => [{ type: "ExternalVehicle", id }]
    }),

    // Create
    createExternalVehicle: builder.mutation({
      query: (payload) => ({
        url: "v1/ExternalVehicle",
        method: "POST",
        body: payload,
        headers: { "Content-Type": "application/json" }
      }),
      invalidatesTags: [{ type: "ExternalVehicle", id: "LIST" }]
    }),

    // Update (PATCH)
    updateExternalVehicle: builder.mutation({
      query: (payload) => ({
        url: "v1/ExternalVehicle",
        method: "PATCH",
        body: payload,
        headers: { "Content-Type": "application/json" }
      }),
      invalidatesTags: (result, error, arg) => [
        { type: "ExternalVehicle", id: arg?.id },
        { type: "ExternalVehicle", id: "LIST" }
      ]
    }),

    // Delete
    deleteExternalVehicle: builder.mutation({
      query: ({ id }) => ({
        url: "v1/ExternalVehicle",
        method: "DELETE",
        body: { id },
        headers: { "Content-Type": "application/json" }
      }),
      invalidatesTags: (result, error, arg) => [
        { type: "ExternalVehicle", id: arg?.id },
        { type: "ExternalVehicle", id: "LIST" }
      ]
    })
  })
});

export const {
  useGetExternalVehiclesQuery,
  useGetExternalVehicleByIdQuery,
  useLazyGetExternalVehicleByIdQuery,
  useCreateExternalVehicleMutation,
  useUpdateExternalVehicleMutation,
  useDeleteExternalVehicleMutation
} = externalVehicleApi;

